import { React, models, kea, history, resources, selectores, componentToRx, Route, withRouter } from "app/main/std";

interface Props {
    value: number;
    color: "primary" | "success" | "info" | "warning" | "danger";
}

class TotalConceptoEnAclaracionNoRx extends React.PureComponent<Props> {
    render() {
        const x = this.props.value
        const lbl = "label label-" + this.props.color;
        const estilo = {
            fontSize: "14px",
            float: "right"
        } as React.CSSProperties;

        return (
            <div className="Container">
                <label className={lbl} style={estilo}>
                    Total: ${x}
                </label>
            </div>
        )
    }
}

export const TotalConceptoList = componentToRx(TotalConceptoEnAclaracionNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/partidasaclaracion/edit/totales.tsx